import { SxProps, Theme } from '@mui/material';

type TStyles = {
  timerContainer: SxProps<Theme>;
};

export const styles: TStyles = {
  timerContainer: (theme) => ({
    textAlign: 'center',
    color: theme.palette.error.main,
    fontSize: { xs: '12px', sm: '14px' },
  }),
};
